import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '~/constants/keys'
import { getTriggerTypes } from '~/dataProcessor/api/api'
import { getTools } from '~/generated/backendProvider'

export const useGetAppActions = (appName: string, usecase: string) => {
  const {
    data: actionsData = {
      items: [],
    },
    isLoading: isActionsLoading,
  } = useQuery({
    queryKey: QUERY_KEYS.getAppActionsQueryKey(appName, usecase),
    queryFn: () =>
      getTools({
        search: usecase,
        toolkitSlug: appName,
        limit: '1000',
      }),
    staleTime: 10000 * 60 * 60 * 24, // 24 hours
    cacheTime: 10000 * 60 * 60 * 24, // 24 hours
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!appName,
  })

  return {
    actionsData,
    isActionsLoading,
  }
}

export const useGetAppTriggers = (slug: string) => {
  const { data: triggersData, isLoading: isTriggerLoading } = useQuery({
    queryKey: QUERY_KEYS.getAppTriggersQueryKey(slug),
    queryFn: () =>
      getTriggerTypes({
        slug: slug,
      }),
  })

  return {
    triggersData,
    isTriggerLoading,
  }
}
